import * as React from 'react';
import { Checkbox } from 'antd';

interface OutlookCheckboxProps {
  onClick: (e: React.MouseEvent) => void;
  // data-id="{id}" to grab it from event.target node
  dataId?: string;
  checked?: boolean;
  intermediate?: boolean;
}

export const OutlookCheckbox = ({ onClick, dataId, checked, intermediate }: OutlookCheckboxProps) => {
  return (
    <Checkbox indeterminate={intermediate} checked={checked} onClick={onClick} data-id={dataId} />
  );
};